import React from 'react'
import PropTypes from 'prop-types'
import { Container, Heading } from '@scentregroup/ui'
import FlipFlop from '../../../components/flip-flop'
import ContentGroup from '../../../components/content-group'
import MoreText from '../../../components/more-text'
import style from './index.scss'

const BLOCKS_TO_DISPLAY = 3

const CategoryDescription = ({ image, description, name }) => (
  <ContentGroup
    angleOrigin={'top-right'}
    color={'Grey'}
    className={style.categoryDescription}
  >
    <Container type="large">
      <FlipFlop
        position="left"
        size="large"
        className={style.flipFlop}
        imageUrl={image.replace(/^http:/, '')}
      >
        <div>
          <Heading className={style.heading} type="medium">
            About {name}
          </Heading>
          <MoreText text={description} limit={BLOCKS_TO_DISPLAY} />
        </div>
      </FlipFlop>
    </Container>
  </ContentGroup>
)

CategoryDescription.propTypes = {
  image: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

export default CategoryDescription
